import { PUBLIC_PROGRESSIONS_PATH } from '../../constants';

export default [
  `${PUBLIC_PROGRESSIONS_PATH}/DAC_211.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/DACG.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/DCGF.mid`,
  // `${PUBLIC_PROGRESSIONS_PATH}/DFAG.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/DGA_211.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/FEaD_112.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/FC_22.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/FCGf_112.mid`,
  `${PUBLIC_PROGRESSIONS_PATH}/FCG_211.mid`,
] as string[];
